import { useEffect, useMemo, useRef } from 'react';
import docs from '~/assets/icons/docs_2.svg';
import helpFaq from '~/assets/icons/help_faq.svg';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { rage, useObservable } from '~/rage';
import { Role } from '~/shared';
import {
	setActiveReportId,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { ReportChat } from '../ReportChat';
import { ReportListItem } from '../ReportListItem/ReportListItem';
import {
	StyledContainer,
	StyledCount,
	StyledCreateButtonContent,
	StyledEmptyList,
	StyledLeftContainer,
	StyledLeftHeadContainer,
	StyledListTitle,
	StyledReportList,
} from './ReportTab.styled';

const ReportTab = () => {
	const dispatch = useLayoutDispatch();
	const reports = useObservable(rage.reports.getReports());
	const activeReportId = useLayoutSelector(
		(state) => state.mainMenu.activeReportId,
	);

	const currentRole = useObservable(rage.accessControl.getCurrentRole());
	const isStaffMember = useMemo(
		() => rage.accessControl.hasMinimumRole(Role.MODERATOR),
		[currentRole],
	);

	const reportListRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		if (activeReportId && reportListRef.current) {
			const activeElement = reportListRef.current.querySelector(
				`[data-report-id="${activeReportId}"]`,
			) as HTMLElement;
			if (activeElement) {
				activeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
			}
		}
	}, [activeReportId]);

	return (
		<StyledContainer>
			<StyledLeftContainer
				style={{ padding: isStaffMember ? '20px 20px 0 20px' : '20px' }}
			>
				<StyledLeftHeadContainer>
					<StyledListTitle>
						<img src={docs} alt="list" />
						<Text>Список обращений</Text>
					</StyledListTitle>
					{isStaffMember && (
						<StyledCount>
							<Text>{reports.length}</Text>
						</StyledCount>
					)}
				</StyledLeftHeadContainer>
				{reports.length > 0 ? (
					<StyledReportList
						ref={reportListRef}
						style={{ height: isStaffMember ? 837 : 727 }}
						tabIndex={-1}
					>
						{reports.map((report) => (
							<ReportListItem
								key={report.id}
								report={report}
								isStaff={isStaffMember}
								active={activeReportId === report.id}
							/>
						))}
					</StyledReportList>
				) : (
					<StyledEmptyList style={{ height: isStaffMember ? 837 : 727 }}>
						<Text>
							{isStaffMember
								? 'Пока нет входящих обращений'
								: 'Если у вас есть вопросы по игре, либо жалобы на других игроков, то вы можете создать обращение на кнопку ниже.'}
						</Text>
					</StyledEmptyList>
				)}
				{!isStaffMember && (
					<Button
						color={ButtonColors.Help}
						height={ButtonHeight.Height60}
						style={{ fontSize: 16, fontWeight: 500, marginTop: 30 }}
						onClick={() => dispatch(setActiveReportId(null))}
						borderRadius={ButtonBorderRadius.Radius5}
					>
						<StyledCreateButtonContent>
							<img src={helpFaq} />
							<Text>Создать новое обращение</Text>
						</StyledCreateButtonContent>
					</Button>
				)}
			</StyledLeftContainer>
			<ReportChat />
		</StyledContainer>
	);
};

export { ReportTab };
